<template>
  <div class="pt-3" v-if="!menu">
    <popupNotice ref="popup" />
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
      height="520px"
    >
      <v-carousel-item
        v-for="(slide,i) in items"
        :key="i"
        :src="slide.image"
      >
      <v-row class="fill-height" align="end" justify="end">
        <v-col cols="12" class="pr-5 pb-5 text-right">
          <div v-html="slide.content"></div>
        </v-col>
        <!-- <div>
          <div class="text-sm-h4 ma-5" style="font-size: 1rem">
            <span class="font-weight-bold" style="color:#fe0303">인피니티투자자문</span>
            <span class="text-sm-h5" style="font-size: 0.8rem">은 미래를 바라봅니다.</span>
          </div>
        </div> -->
      </v-row>
      </v-carousel-item>
    </v-carousel>

    <v-container fluid>
      <v-row justify="center" class="pt-15">
        <v-col cols="12">
          <p class="text-center text-sm-h5 font-weight-bold" style="font-size: 1.5rem">사업소개</p>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col
          v-for="(item, i) in banner"
          :key="i"
          cols="12"
          sm="6"
          md="3"
        >
          <v-card
            class="mx-auto"
          >
            <v-img :src="item.image">
            </v-img>
            <v-card-title>
              {{ item.title }}
            </v-card-title>
            <!-- <v-card-subtitle class="pt-2" v-html="item.subtitle" /> -->
            <v-card-subtitle class="pt-2"><span v-html="item.subtitle"></span></v-card-subtitle>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text :to="item.page">
              <span class="caption">자세히 보기</span>
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="pt-15">
        <v-col cols="12">
          <p class="text-sm-h5 text-center font-weight-bold" style="font-size: 1.5rem">인피니티투자자문 오시는 길</p>
        </v-col>
      </v-row>
    </v-container>

    <v-row no-gutters>
      <v-col cols="12" sm="5">
        <v-card class="d-flex justify-end blue-grey lighten-4 pa-5" outlined tile height="331">
          <div style="width: 570px">
          <v-card-subtitle>
            <div class="title" style="font-weight: 800">주소</div>
            <p class="subtile-1" style="font-size:1.3rem">07327 서울특별시 영등포구 국제금융로2길 32,<br>13층(여의도동, 여의도파이낸스타워)</p>
            <div class="title">TEL <span style="font-size:1.3rem">02-784-7670</span></div>
            <p class="title">FAX <span style="font-size:1.3rem">02-784-7677</span></p>
            <div class="title">E-Mail</div>
            <p class="" style="font-size:1.3rem">contact@infinityasset.com</p>
          </v-card-subtitle>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="7">
        <!-- 지도의 중심 좌표 -->
        <v-card outlined tile height="331">
           <vue-daum-map
            :appKey="appKey"
            :center="mapCenter"
            :level.sync="level"
            :mapTypeId="mapTypeId"
            :libraries="libraries"
            @load="onLoad"
            @update:center="center=$event"
            style="height:328px;"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-row no-gutters align="center" justify="center" style="background-color: #B71C1C" v-show="isShow">
      <v-col cols="4">
        <span class="px-5 float-right white--text">인피니티 소식</span>
      </v-col>
      <v-col cols="6">
        <v-card tile>
          <v-carousel
            cycle
            height="46"
            hide-delimiter-background
            show-arrows-on-hover
            hide-delimiters
          >
            <v-carousel-item
              v-for="(slide, i) in slides"
              :key="i"
              :to="`?menu=5&page=tab-1&row=${slide.BSNO}`"
            >
              <v-sheet
                color="red darken-4"
                height="100%"
              >
                <v-row
                  dense
                  class="fill-height ma-0"
                  align="center"
                  justify="start"
                >
                  <v-col cols="12" class="text-center">
                    <div>{{ reTitle(slide.TITLE_VC) }} <v-icon v-if="slide.OFILE_VC" small>mdi-paperclip</v-icon><span class="ml-7">{{ slide.WDATE_VC.substring(0, 10) }}</span></div>
                  </v-col>
                <!--
                  <v-col cols="9" class="d-flex justify-center">
                    {{ slide.text }} <v-icon small>mdi-paperclip</v-icon>
                  </v-col>
                  <v-col cols="3">
                    {{ slide.date }}
                  </v-col>
                -->
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-col>
      <v-col cols="2">
      </v-col>
    </v-row>
  </div>
  <div v-else-if="menu==1">
    <Menu01 />
  </div>
  <div v-else-if="menu==2">
    <Menu02 />
  </div>
  <div v-else-if="menu==3">
    <Menu03 />
  </div>
  <div v-else-if="menu==4">
    <Menu04 />
  </div>
  <div v-else-if="menu==5">
    <Menu05 />
  </div>

</template>

<script>
  import Menu01 from '@/components/Menu01.vue';
  import Menu02 from '@/components/Menu02.vue';
  import Menu03 from '@/components/Menu03.vue';
  import Menu04 from '@/components/Menu04.vue';
  import Menu05 from '@/components/Menu05.vue';
  import VueDaumMap from 'vue-daum-map';
  import 'vueperslides/dist/vueperslides.css';

  //import board from "@/assets/json/board.json";
  import popupNotice from "@/components/dialogs/PopupNotice";

  export default {
    components: { VueDaumMap, Menu01, Menu02, Menu03, Menu04, Menu05, popupNotice },
    data: () => ({
      menu: 0,

      links: ['경영이념','회사소개','품질경영','사업분야','정보마당'],
      items: [
        { image: require('@/assets/images/main01.jpg'), content: content },
        { image: require('@/assets/images/main02.jpg'), content: content },
        { image: require('@/assets/images/main03.jpg'), content: content },
        { image: require('@/assets/images/main04.jpg'), content: content }
      ],

      banner: [
        {image: require('@/assets/images/menu01.jpg'), page: '?menu=2&page=tab-4', title: 'INFINITY POWER', subtitle: '인피니티투자자문의 차별화된<br>특징과 강점을 소개합니다.' },
        {image: require('@/assets/images/menu02.jpg'), page: '?menu=2&page=tab-3', title: 'SERVICE FLOW', subtitle: '인피니티투자자문은 고객만족을 위한<br>서비스로 한 발 더 다가서겠습니다.' },
        {image: require('@/assets/images/menu03.jpg'), page: '?menu=4&page=tab-1', title: 'INFINITY TEAM', subtitle: '믿을 수 있는 인피니티투자자문의<br>운용인력을 소개합니다.' }
      ],
      text1: text1,
      slides: [],

      appKey: 'c78f2395692dd0ecca999d9543196d3e',
      mapCenter: {lat:37.52388267266389, lng:126.92413793738014},
      level: 3, // 지도의 레벨(확대, 축소 정도),
      mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
      libraries: ['services'], // 추가로 불러올 라이브러리
      map: null, // 지도 객체. 지도가 로드되면 할당됨.

      dataList: [],
      isShow: false,

      boardlist: [] //board
    }),
    created() {
      this.$http.get(`${process.env.VUE_APP_API_URL}/getNews`)
        .then(response => {
          if (response.status === 200) {
            this.isShow = true;
            this.dataList = response.data;
            this.slides = response.data.slice(0, 5);
          } else {
            this.isShow = false;
            this.slides = [];
          }
        })
        .catch(error => {
          console.error("API 요청 실패:", error);
          this.isShow = false;
          this.slides = [];
        });
    },
    mounted() {
      this.menu = this.$route.query.menu;
      this.getCookie();
    },
    methods: {
      onLoad (map) {
        this.map = map;

        var daummaps = window.daum.maps;
        if (daummaps) {
          //var latlng = new daummaps.LatLng(37.524006, 126.924499)
          //var latlng = new daummaps.LatLng(37.523862409207986, 126.92415209859867)
          //var latlng = new daummaps.LatLng(37.524877, 126.927325)
          var latlng = new daummaps.LatLng(37.52388267266389, 126.92413793738014)
          var marker = new daummaps.Marker({
            position: latlng
          })

          marker.setMap(map)
          this.map = map
        }
      },
      reTitle(str) {
        return str.replace("<br/>", "");
      },
      getCookie(){
        var cookies = document.cookie.split(';');
        cookies.forEach(val => {
          console.log(val);
          if(val.trim() != 'isNotice') {
            this.$refs.popup.showDialog();
          }
        });
      }
    }
  }
  const text1 = `
  안정적이고 우수한 운용 수익률을 지속적으로 실현하고<br>
  고객의 재산을 내 재산같이 운용하여<span class="amber--text"> 고객의 발전과 함께하는</span><br>
  <span class="amber--text">인피니티투자자문</span>이 되도록 최선의 노력을 다하겠습니다.`;

  const content = `
  <div class="pb-2 text-lg-h3 text-h4 white--text">고객님의 내일은 저희의 책임입니다.</div>
  <div class="text-lg-h1 white--text font-weight-bold pb-2">INFINITY INVESTMENT<br>ADVISORY CO., LTD</div>
  <div class="text-lg-h4 font-weight-bold red--text">인피니티투자자문
    <span class="text-lg-h5 white--text">은 미래를 바라봅니다.</span>
  </div>
  `
</script>

<style>
  .v-window__prev, .v-window__next {
    background: transparent !important;
  }
/*
  .v-btn:before {
    background-color: transparent !important;
  }
*/
</style>